import { useSelector } from 'react-redux';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useQueryParams from '../../../navigation-utils/useQueryParams';
import { selectMetadataTypesList } from '../../../reducers/documentation/metadataReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import { SalesforceItem } from '../../parser/ParserTypes';

export function useMetadataHandleDeepLink({
  onRowClick,
  elements,
  crmOrgId,
}: {
  elements: SalesforceItem[];
  onRowClick: (
    event: React.MouseEvent<HTMLTableCellElement>,
    row: { id: string; _name: string; _type: string; _parentType: string },
  ) => void;
  crmOrgId: string;
}) {
  const queryParams = useQueryParams();
  const elementsLoaded = useSelector(selectMetadataTypesList(crmOrgId));

  useRunOnceWhenTruthy(() => {
    const configurationItemId = queryParams.get(DeepLinkSearchParams.configurationItemId);
    if (configurationItemId) {
      const [, configurationName] = configurationItemId.split('|');
      const row = elements.find((element) => element.name === configurationName);
      if (row) {
        onRowClick({ target: {} } as React.MouseEvent<HTMLTableCellElement>, {
          id: row.id,
          _name: row.name,
          _type: 'fieldType' in row ? row.fieldType : '',
          _parentType: row.parentType,
        });
      }
    }
  }, Boolean(elementsLoaded));
}
